import styled from 'styled-components';
import { palette } from '@m12s/component-library';
import { MobileIcon } from '../styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: fit-content;
`;

const Title = styled.span`
  color: ${({ disabled }) => {
    return disabled ? palette.Grey600 : palette.Grey700;
  }};
  text-align: center;
  font-size: 4.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: 6.5rem;
`;

const Subtitle = styled.div`
  color: ${({ disabled }) => {
    return disabled ? palette.Grey600 : palette.Grey700;
  }};
  text-align: center;
  font-size: 2.188rem;
  font-style: normal;
  font-weight: 500;
  line-height: 3.281rem;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.875rem;

  padding-top: 1.75rem;
  border-top: thin solid ${palette.Grey400};
  width: 100%;
`;

const CustomMobileIcon = styled(MobileIcon)`
  margin-right: 0 !important;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 8.75rem;
  color: ${({ disabled }) => {
    return disabled ? palette.Indigo500 : palette.Indigo600;
  }};
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%; /* 16px */
  text-transform: uppercase;
`;

const ShiftIndicatorIcon = styled(MobileIcon)`
  margin-right: 0 !important;
  color: ${({ disabled }) => {
    return disabled ? palette.Indigo500 : palette.Indigo600;
  }};
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  padding-top: 2rem;
`;

export {
  Container,
  Body,
  Title,
  Subtitle,
  CustomMobileIcon,
  Header,
  ShiftIndicatorIcon,
  Footer,
};
